module.exports = __webpack_public_path__ + "static/img/nodata.684adc65.png";